<template>
  <div
    class="fts-event-toggle"
    @click="open"
    @mouseenter="expand = true"
    @mouseleave="expand = false"
  >
    <font-awesome-icon :icon="getEventIcon" fixed-width />
    <transition name="event-fade">
      <div class="event-toggle-overlay" v-if="expand">
        <fts-btn
          outline
          color="var(--fts-primary)"
          text-transform-init
          class="event-toggle-btn"
        >
          {{getEventLabel}}
          <font-awesome-icon
            :icon="getEventIcon"
            fixed-width
            class="event-toggle-btn-icon"
          />
        </fts-btn>
      </div>
    </transition>
  </div>
</template>

<script>
import FTSBtn from "../../elements/FTSBtn";

export default {
  props: {
    eventType: String,
  },
  components: {
    "fts-btn": FTSBtn,
  },
  data: () => ({
    expand: false,
  }),
  methods: {
    open() {
      this.$emit('open');
    },
  },
  computed: {
    isNotification() {
      return this.eventType && this.eventType.toLowerCase() === 'notification';
    },
    getEventIcon() {
      if (this.isNotification)
        return ['far', 'envelope'];
      else
        return ['fas', 'bolt'];
    },
    getEventLabel() {
      if (this.isNotification)
        return 'New Notification';
      else
        return 'New Automation';
    },
  },
}
</script>

<style lang="scss" scoped>
.fts-event-toggle {
  position: relative;
  display: flex;
  align-items: center;
  font-size: .875rem;
  color: var(--fts-gray-5);
  .event-toggle-overlay {
    position: absolute;
    right: -0.813rem;
    white-space: nowrap;
    z-index: 1;
    .event-toggle-btn.fts-btn {
      min-height: auto;
      height: auto;
      border-radius: 10em;
      background-color: var(--fts-background);
      font-size: .75rem;
      .event-toggle-btn-icon {
        margin-left: .375rem;
        margin-right: 0;
        font-size: .875rem;
      }
    }
  }
  /* transition */
  .event-fade-enter-active, 
  .event-fade-leave-active {
    transition: opacity .2s linear;
  }
  .event-fade-enter, 
  .event-fade-leave-to {
    opacity: 0;
  }
}
</style>